/**
 * Preguntas predeterminadas del formulario RSVP.
 * Si rsvp_invites.form_questions es null, se usan estas.
 * Tipos: attendance (asistencia), dietary (restricciones), allergies (texto), notes (textarea),
 * custom_text, custom_textarea, custom_choice (preguntas creadas por el usuario).
 */
export const DEFAULT_RSVP_QUESTIONS = [
  {
    id: 'attendance',
    type: 'attendance',
    label: 'Will you be able to join us at our wedding? Kindly reply by {{date}}.',
    required: true,
    options: [
      "Yes, I wouldn't miss it :)",
      "No, I won't be able to make it :(",
    ],
  },
  {
    id: 'dietary',
    type: 'dietary',
    label: 'Do you have any dietary restrictions?',
    required: false,
    options: ['None', 'Vegetarian', 'Vegan', 'Celiac', 'Kosher', 'Pescatarian'],
    multiple: false,
  },
  {
    id: 'allergies',
    type: 'allergies',
    label: 'Any Food allergies? (Wheat, Nuts, Fish, Shellfish, Eggs, Soy, etc.)',
    placeholder: 'Please specify',
    required: false,
  },
  {
    id: 'notes',
    type: 'notes',
    label: 'Any additional information we should know? (e.g., wheelchair access needed, special requests, etc.)',
    placeholder: 'Please let us know if you have any special needs or requests...',
    required: false,
  },
]

/**
 * Sustituye {{date}} en el label por la fecha de la boda formateada
 */
export function formatQuestionLabel(label, weddingDate) {
  if (!label || !weddingDate) return label || ''
  try {
    const date = new Date(weddingDate)
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const dateStr = `${days[date.getDay()]} ${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`
    return label.replace(/\{\{date\}\}/g, dateStr)
  } catch {
    return label.replace(/\{\{date\}\}/g, 'the wedding date')
  }
}

/**
 * Devuelve las preguntas a mostrar: form_questions si existe, si no las predeterminadas
 */
export function getFormQuestions(invite) {
  const raw = invite?.form_questions
  if (raw && Array.isArray(raw) && raw.length > 0) {
    return raw
  }
  return DEFAULT_RSVP_QUESTIONS.map((q) => ({ ...q }))
}

/**
 * Genera un id único para una nueva pregunta custom
 */
export function nextCustomQuestionId(existingQuestions) {
  const ids = new Set((existingQuestions || []).map((q) => q.id))
  let n = 1
  while (ids.has(`custom-${n}`)) n++
  return `custom-${n}`
}
